import React from 'react';
import { r } from './helpers';
import TrackingPage from '../../pages/customer/TrackingPage';

/** Customer subdomain (customer-{slug}.domain) — public tracking. */
export function CustomerRoutes() {
  return (
    <>
      {r('/', <TrackingPage />)}
    </>
  );
}